<template>
  <div v-editable="editing && blok" class="sb-post">
    <hgroup class="2xl:container px-[2rem] 2xl:mx-auto">
      <Breadcrumbs />
    </hgroup>
    <div class="sb-post__top"></div>
    <div class="sb-post__content px-[2rem] mb-[100px]">
      <div class="sb-post__content-wrapper 2xl:container lg:grid grid-cols-12 gap-x-8 mx-auto">
        <p class="content__date col-start-2 col-span-4 mb-0">
          {{
          date.toLocaleString(locale, {
          month: "long",
          day: "numeric",
          year: "numeric",
          })
          }}
        </p>
        <div class="content__categories mb-[3rem]   col-start-2 col-span-5 font-bold text-aj-purple-100">
          <a class="mr-.5rem" v-for="(cat, ck) in getCategoriesByID(blok.categories)" :key="ck">{{ cat.name }}</a>
        </div>
        <!-- <h1 class="content__header col-start-2 col-span-5 mb-[3rem] lg:mb-[5rem] ">
          {{ is_visual_title && renderRichText(blok.visual_title)  || parent.name }}
        </h1> -->
        <h1 class="content__header col-start-2 col-span-5 mb-[3rem] lg:mb-[5rem]" >{{ renderRichText(blok.visual_title).replace(/<[^>]*>/g, '')  || blok?.title
          || parent?.name || 'Page title missing'}}</h1>
        <!-- <div class="sb-page__visual-title font-serif  col-start-2 col-span-5 mb-[3rem] lg:mb-[5rem]"
          v-if="is_visual_title" v-html="renderRichText(blok.visual_title)"></div> -->

        <div v-if="blok.featured_image?.filename && blok.show_featured_image"
          class="content__featured_image sb-media object-cover mb-[3rem] lg:mb-[5rem]  col-start-1 col-span-12 aspect-4/3">
          <img :src="blok.featured_image.filename + image_compression_default" :alt="blok.featured_image.alt || ''" />
        </div>
        <p v-if="blok.show_featured_image && (blok.featured_image?.title || blok.featured_image?.name)"
          class="col-start-12 col-end-9 text-right my-[1rem]">
          {{ blok.featured_image.title || blok.featured_image.name }}
        </p>

        <div class="content__body sb-textfield mb-[3rem] lg:mb-[5rem] col-start-2 col-span-4 richtext"
          v-html="body_content"></div>
      </div>
    </div>
    <div v-if="blok.references?.length" class="sb-post__references sb-section sb-section--rounded bg-aj-grey-light">
      <div class="sb-section__inner 2xl:container grid grid-cols-12 gap-x-8">
        <div class="references col-start-2 col-span-4">
          <p class="font-bold">References</p>
          <ul class="list-decimal pl-[2rem]">
            <li v-for="(ref, rk) in blok.references" :key="rk">
              <a :href="ref.link.url" :target="ref.link.target" class="ref-link" :id="'ref' + (rk + 1)">
                {{ ref.label || ref.link.url }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { locale, locales } = useI18n();
const { blok, parent, view } = defineProps({
  blok: Object,
  parent: Object,
  view: String,
});
const { getCategoriesByID } = useConfig();
const { parseMarkdown } = useToolBox();
const { editing, image_compression_default} = useSettings();
const body_content = computed(() => {
  let ret = renderRichText(blok.content);
  // console.log(ret.match(/\[(.*)]/gm))
  //console.log(ret)
  ret = ret.replace(
    /\[(.?)]/g,
    "<a class='richtext__reference' href='#ref$1'>$&</a>"
  );
  return ret;
});
let date = new Date(parent.first_published_at);
// console.log(blok)
console.log(blok)
let is_visual_title = computed(() => {
  return blok.visual_title && renderRichText(blok.visual_title) != "<p></p>";
});
</script>
<style lang="scss">
.sb-post {
  padding-top: 150px;

  &__content {

    padding-top: 150px;
    .sb-section:first-child {
      padding-top: 280px;
    }
    .content__categories{
      > a{
        margin-right:.5rem;
      }
    }
    .content__featured_image {
      // background-color: hotpink;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
    .content__header{
      &+.content__body{
        margin-top:0px;
      }
    }
    &:last-child{
      padding-bottom:30rem;
      margin-bottom: 0px;
    }
  }
  &__top {
    display: block;
    position: absolute;
    height: 250px;
    width: 100%;
    top: 0px;
    background-color: $c-grey-light;
  }
  hgroup {
    z-index: 2;
    position: relative;
  }
}
</style>
